module.exports = __webpack_public_path__ + "static/dashboard_updated-343f8f620d194c4d651262fb2e1bb0d0.png";